"use client";
import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import { Sidebar } from "primereact/sidebar";
import ReactEcharts from "echarts-for-react";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import arrowleft from '../../../assets/images/arrow-left.png';
import arrowright from '../../../assets/images/arrow-right.png';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import StackedBarChart from "../charts/stackedbarchart";
import { fetchAttendance_Dimension_View } from "../../../redux/slices/attendance";
import { useDispatch, useSelector } from "react-redux";
import LoaderContainer from "../../../components/LoaderContainer/LoaderContainer";

export default function AttendanceSideBar2(props) {
    const { visible, onHide, setActiveIndexList } = props;
    const [activeTab, setActiveTab] = useState(0);
    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    /* Redux State */
    const dispatch = useDispatch();
    const Attendance_Dimension_View = useSelector(state => state.attendance.Attendance_Dimension_View);
    const Attendance_Dimension_ViewLoading = useSelector(state => state.attendance.Attendance_Dimension_Viewloading);

    const appliedfilter = useSelector(state => state.filter.appliedFilters);
    /* */

    /* API Call */
    useEffect(() => {
        if (visible) {
            dispatch(fetchAttendance_Dimension_View({
                "elasticQueryName": "Attendance Dimension View",
                "filters": [{ "columnName": "METRIC_ID", "columnValue": 10012, "excludeKeyword": false }].concat(appliedfilter),
                "dynamicColumns": [
                    { "columnName": "#{dimension}", "columnValue": TabOption[activeTab].code },
                    { "columnName": "#{school_name}", "columnValue": 'and 1=1' }
                ],
            }));
        }
    }, [visible, activeTab, appliedfilter])
    /* */
    
    const Chronic = Attendance_Dimension_View?.filter(item => item?.INCIDENT_TYPE == 'CHRONIC');
    const Non_Chronic = Attendance_Dimension_View?.filter(item => item?.INCIDENT_TYPE == 'NOT_CHRONIC');

    const EthinicityRates = {
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' }
        },
        grid: {
            left: '3%',
            right: '0%',
            bottom: '13%',
            top: '5%',
            containLabel: true
        },
        legend: {
            data: ["Moved into Chronic Absence", "Moved Out of Chronic Absence"],
            bottom: 0,
            left: 0,
            itemGap: 10,
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
                color: '#E0E3E9',
                fontSize: 12,
                fontWeight: 100
            },
        },
        xAxis: {
            type: 'category',
            data: Chronic?.map(item => item?.DIMENSION),
            axisLabel: { 
                color: "#E0E3E9",
                fontSize: 11,
                formatter: function (value) {
                    const maxLen = 5; // set max length
                    return value.length > maxLen ? value.slice(0, maxLen) + '...' : value;
                }
            },
            name: 'Ethnicity',
            nameLocation: "middle",
            nameGap: 30,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            // min: 0,
            // max: 100,
            // interval: 10,
            axisLabel: {
                color: '#E0E3E9',
                fontSize: 12,
                formatter: '{value}'
            },
            name: '# of Students',
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 40,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            splitLine: {
                lineStyle: {
                    color: "#42536D"
                }
            }
        },
        series: [
            {
                name: 'Moved into Chronic Absence',
                type: 'bar',
                barGap: '5%',
                barWidth: "40%",
                // data: [74, 54.5, 78, 70.2, 80.9, 85.9],
                data: Chronic?.map(item => item?.CURRENT_PERIOD),
                itemStyle: {
                    color: '#D46A6A',
                    borderRadius: [3, 3, 0, 0]
                },
                label: {
                    show: true,
                    position: 'top',
                    color: '#E0E3E9',
                    formatter: '{c}'
                }
            },
            {
                name: 'Moved Out of Chronic Absence',
                type: 'bar',
                barGap: '5%',
                barWidth: "40%",
                // data: [60, 35.5, 50, 27.5, 60, 80],
                data: Non_Chronic?.map(item => item?.CURRENT_PERIOD),
                itemStyle: {
                    color: '#129C83',
                    borderRadius: [3, 3, 0, 0]
                },
                label: {
                    show: true,
                    position: 'top',
                    color: '#E0E3E9',
                    formatter: '{c}'
                }
            }
        ],
    }

    const SchoolTypeRates = {
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' }
        },
        grid: {
            left: '3%',
            right: '0%',
            bottom: '13%',
            top: '5%',
            containLabel: true
        },
        legend: {
            data: ["Moved into Chronic Absence", "Moved Out of Chronic Absence"],
            bottom: 0,
            left: 0,
            itemGap: 10,
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
                color: '#E0E3E9',
                fontSize: 12,
                fontWeight: 100,
            },
        },
        xAxis: {
            type: 'category',
            data: Chronic?.map(item => item?.DIMENSION),
            axisLabel: { 
                color: "#E0E3E9",
                fontSize: 12,
            },
            name: 'School Type',
            nameLocation: "middle",
            nameGap: 30,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            // min: 0,
            // max: 100,
            // interval: 10,
            axisLabel: {
                color: '#E0E3E9',
                fontSize: 12,
                formatter: '{value}'
            },
            name: 'Percentage of Students Proficient',
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 40,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            splitLine: {
                lineStyle: {
                    color: "#42536D"
                }
            }
        },
        series: [
            {
                name: 'Moved into Chronic Absence',
                type: 'bar',
                barGap: '5%',
                barWidth: '40%',
                // data: [74, 58, 57.5],
                data: Chronic?.map(item => item?.CURRENT_PERIOD),
                itemStyle: {
                color: '#D46A6A',
                borderRadius: [3, 3, 0, 0]
                },
                label: {
                show: true,
                position: 'top',
                color: '#E0E3E9',
                formatter: '{c}'
                }
            },
            {
                name: 'Moved Out of Chronic Absence',
                type: 'bar',
                barGap: '5%',
                barWidth: '40%',
                // data: [51, 83, 32.5],
                data: Non_Chronic?.map(item => item?.CURRENT_PERIOD),
                itemStyle: {
                color: '#129C83',
                borderRadius: [3, 3, 0, 0]
                },
                label: {
                show: true,
                position: 'top',
                color: '#E0E3E9',
                formatter: '{c}'
                }
            },
        ],
    }

    const GenderRates = {
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
        },
        grid: {
            top: '5%',
            left: '3%',
            right: '4%',
            bottom: '13%',
            containLabel: true,
        },
        legend: {
            // show: false,
            data: ["Moved into Chronic Absence", "Moved Out of Chronic Absence"],
            bottom: 0,
            left: 0,
            itemGap: 10,
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
                color: '#E0E3E9',
                fontSize: 12,
                fontWeight: 100
            },
        },
        xAxis: {
            type: 'category',
            // data: ['Male', 'Female', 'Others'],
            data: Chronic?.map(item => item?.DIMENSION),
            axisLabel: { 
                color: "#E0E3E9",
                fontSize: 12,
            },
            name: 'Genders',
            nameLocation: "middle",
            nameGap: 30,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            axisTick: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            // min: 0,
            // max: 100,
            // interval: 10,
            axisLabel: {
                color: '#E0E3E9',
                fontSize: 12,
                formatter: '{value}'
            },
            name: 'Percentage of Students Proficient',
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 40,
            nameTextStyle: {
                fontSize: 12,
                color: '#9EA3AA',
            },
            splitLine: {
                lineStyle: {
                    color: "#42536D"
                }
            }
        },
        series: [
            {
                name: 'Moved into Chronic Absence',
                type: 'bar',
                barGap: '5%',
                barWidth: '40%',
                // data: [74, 58, 57.5],
                data: Chronic?.map(item => item?.CURRENT_PERIOD),
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}',
                    color: '#fff',
                },
                itemStyle: {
                    color: '#D46A6A',
                    borderRadius: [3, 3, 0, 0]
                },
            },
            {
                name: 'Moved Out of Chronic Absence',
                type: 'bar',
                barGap: '5%',
                barWidth: '40%',
                // data: [51, 83, 32.5],
                data: Non_Chronic?.map(item => item?.CURRENT_PERIOD),
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}',
                    color: '#fff',
                },
                itemStyle: {
                    color: '#129C83',
                    borderRadius: [3, 3, 0, 0]
                },
            },
        ],
    }

    const CustChart = React.memo(({ options }) => {
        return <ReactEcharts option={options} style={{ width: '100%', height: '100%' }} />;
    });

    const TabOption = {
        0 : {name: 'Ethnicity', code: 'student_ethnicity'},
        1 : {name: 'Gender', code: 'student_gender'},
        2 : {name: 'School Type', code: 'school_type'},
    }
    return(
        <>
            <Sidebar
                visible={visible}
                onHide={onHide}
                position="right"
                className="custmSidebar 2xl:w-[18.75vw] bg-[#15181F]"
                blockScroll={true}
            >
                <div className="p-[20px]">
                    <div className="text-[#F2F2F5] text-[16px] pb-5">Dimension View</div>
                    <div className="bg-[#272321e6] rounded-[6px] mt-5 border border-[#ffffff1a]">
                        <div className="px-3 py-2 text-[16px] text-[#fff] font-medium border-b border-[#ffffff1a]">{TabOption[activeTab].name} - # of Students Moving in and out of Chronic Absence</div>
                        <div className="px-4 mb-2">
                            <Tabs selectedIndex={activeTab} onSelect={handleTabClick}>
                                <TabList>
                                    <div className="flex items-center mb-1">
                                        <Tab>
                                            <div className={`${ activeTab === 0 ? " bg-[#4c3428]" : " bg-[#141110]" } text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-bl-[5px] cursor-pointer `}>Ethnicity</div>
                                        </Tab>
                                        <Tab>
                                            <div className={`${ activeTab === 1 ? " bg-[#4c3428]" : " bg-[#141110]" } text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] cursor-pointer `}>Gender</div>
                                        </Tab>
                                        <Tab>
                                            <div className={`${ activeTab === 2 ? " bg-[#4c3428]" : " bg-[#141110]" } text-[12px] px-3 py-2 text-[#E0E3E9] leading-[15px] rounded-br-[5px] cursor-pointer `}>School Type</div>
                                        </Tab>
                                    </div>
                                </TabList>
                            </Tabs>
                            <Tabs 
                                selectedIndex={activeTab} 
                                onSelect={handleTabClick} 
                                style={{ width: "100%" }}
                            >
                                <TabPanel>
                                    <div className="h-[400px]">
                                        <LoaderContainer loading={Attendance_Dimension_ViewLoading} width={'100%'} height={'100%'}>
                                        <CustChart options={EthinicityRates} />
                                        </LoaderContainer>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div className="h-[400px]">
                                        <LoaderContainer loading={Attendance_Dimension_ViewLoading} width={'100%'} height={'100%'}>
                                        <CustChart options={GenderRates} />
                                        </LoaderContainer>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div className="h-[400px]">
                                        <LoaderContainer loading={Attendance_Dimension_ViewLoading} width={'100%'} height={'100%'}>
                                        <CustChart options={SchoolTypeRates} />
                                        </LoaderContainer>
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </Sidebar>
        </>
    )
}